function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0-highlight{fill:#42a5f5;}\r\n\t.st1-highlight{fill:none;stroke:#42a5f5;stroke-width:36;stroke-linecap:round;stroke-miterlimit:10;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "SUBRAYAR"
}, /*#__PURE__*/React.createElement("rect", {
  y: 418.06,
  className: "st0-highlight",
  width: 298.7,
  height: 41.61
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0-highlight",
  points: "342.31,30.92 478.22,74.24 378.86,391.62 231.43,341.72  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1-highlight",
  d: "M352.89,390.11l-100.16-32.57c-11.13-3.62-17.22-15.57-13.6-26.7l93.71-288.18 c3.62-11.13,15.57-17.22,26.7-13.6l100.16,32.57c11.13,3.62,17.22,15.57,13.6,26.7L379.6,376.52 C375.98,387.64,364.02,393.73,352.89,390.11z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "416.09,264.29 275.63,218.62 340.02,21.7 406.84,32.21 479.77,69.55  "
}), /*#__PURE__*/React.createElement("path", {
  d: "M326.65,438.92l-81.4-26.47c-7.54-2.45-11.66-10.55-9.21-18.09l7.99-24.56c2.45-7.54,10.55-11.66,18.09-9.21l81.4,26.47 c7.54,2.45,11.66,10.55,9.21,18.09l-7.99,24.56C342.29,437.25,334.19,441.37,326.65,438.92z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M295.85,460.31l-38.58-0.59c-4.57-0.07-7.35-5.24-5.64-10.5l15.89-48.86l48.23,15.68l-12.37,38.04 C302.17,457.8,299.07,460.36,295.85,460.31z"
})));

var SvgHighlight = function SvgHighlight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHighlight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/highlight.f79dcf5e.svg";
export { ForwardRef as ReactComponent };